var _circle, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmployment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 140",
    width: "150px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 60,
    fill: "#ddd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.75,
    y: 70.2,
    width: 47.7,
    height: 55.2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 68.2,
    width: 48.7,
    height: 55.2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.97 123.4 9.5 123.4 9.5 68.2 21.04 68.2 46.97 123.4",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M53.07,73.36v2.42l-4.88.72-1.64.21-1.66.21V77l1.66.31,1.64.31,4.88,1.12v2l-4.88,1.12-1.62.31-1.67.31v.06l1.66.22,1.63.22,4.88.72v2.26L42.64,84.08v-3l4.74-1,1.22-.23,1.19-.18v-.06l-1.19-.2-1.22-.23-4.74-1V75.3Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,86.74q.91,1,1.7,1.78t1.49,1.39a8.11,8.11,0,0,0,1.3.91,2.39,2.39,0,0,0,1.14.33,1.57,1.57,0,0,0,1.14-.38,1.41,1.41,0,0,0,.39-1.06,1.65,1.65,0,0,0-.31-1,5.49,5.49,0,0,0-.73-.82l1.26-1.28a5.84,5.84,0,0,1,1.21,1.54A4,4,0,0,1,53,90a3.86,3.86,0,0,1-.23,1.37,3.15,3.15,0,0,1-.66,1.06,2.87,2.87,0,0,1-1,.69,3.51,3.51,0,0,1-1.33.24,3.42,3.42,0,0,1-1.3-.27,7.1,7.1,0,0,1-1.33-.73,14,14,0,0,1-1.33-1q-.66-.58-1.3-1.21,0,.38.09.86c0,.31,0,.59,0,.84v2h-2V86.74Z",
    fill: "#666"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.36,
    y: 9.79,
    width: 35,
    height: 53.2,
    rx: 2.11,
    ry: 2.11
  })), /*#__PURE__*/React.createElement("rect", {
    x: 31.77,
    y: 8.21,
    width: 35,
    height: 53.2,
    rx: 2.11,
    ry: 2.11,
    fill: "#0af"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.87,
    y: 13.19,
    width: 25.28,
    height: 25.91,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3,39c0-5.89,4.77-8.89,10.67-8.89s10.67,3,10.67,8.89",
    fill: "#666",
    stroke: "#000",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.18,14.83c-3.17.59-5.52,2.82-5.52,5.48a4.5,4.5,0,0,0,.25,1.45h0c-.56,0-1,.63-1,1.42a1.43,1.43,0,0,0,.73,1.35,3.3,3.3,0,0,0-.08.67c0,1.78,1.43,3.33,3.56,4.18.51.75,2,1.3,3.75,1.3s3.24-.55,3.75-1.3c2.13-.85,3.56-2.4,3.56-4.18a3.3,3.3,0,0,0-.08-.67,1.43,1.43,0,0,0,.73-1.35c0-.78-.46-1.42-1-1.42h0A4.5,4.5,0,0,0,57,20.31c0-2.8-2.6-5.11-6-5.56Z",
    fill: "#ccad7a"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.57,
    y1: 44.63,
    x2: 58.89,
    y2: 44.63,
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2,
    strokeDasharray: "4 1.5 2 1.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.57,
    y1: 49.61,
    x2: 45.73,
    y2: 49.61,
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2,
    strokeDasharray: "4 1.5 2 1.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.57,
    y1: 55.23,
    x2: 53.89,
    y2: 55.23,
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2,
    strokeDasharray: "4 1.5 2 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.52,28.69a7.63,7.63,0,0,0,1.58.85c.51.75,2,1.3,3.75,1.3s3.24-.55,3.75-1.3a7.77,7.77,0,0,0,1.4-.73",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.63,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.61,
    y1: 16.38,
    x2: 48,
    y2: 15.1,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.63,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "47.1 25.45 47.76 25.78 51.94 25.81 52.61 25.48",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.63,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.69,
    cy: 21.36,
    rx: 0.64,
    ry: 1.31,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.01,
    cy: 21.36,
    rx: 0.64,
    ry: 1.31,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.34,19.79s-7.12-3.06-9.94-3.06C45.68,18,41.23,25.65,43,17c.31-1.5,2.82-2.76,5.63-2.94C60.55,13.35,58,24,56.34,19.79Z",
    fill: "#666"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "129.66 119.02 139.47 119.02 129.66 126.53 129.66 119.02"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 72.4,
    y: 48.84,
    width: 52.2,
    height: 80.22,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.6,48.84H72.4v80.22h52.22",
    fill: "#666",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.12,63.83H77.69V54.14h6.43Zm0,15H77.69V69.12h6.43Zm0,15H77.69V84.11h6.43Zm0,15H77.69V99.09h6.43Zm11.73-45H89.42V54.14h6.43Zm0,15H89.42V69.12h6.43Zm0,15H89.42V84.11h6.43Zm0,15H89.42V99.09h6.43Zm11.73-45h-6.43V54.14h6.43Zm0,15h-6.43V69.12h6.43Zm0,15h-6.43V84.11h6.43Zm0,15h-6.43V99.09h6.43Zm0,5.29v11.8H89.42v-11.8ZM119.3,63.83h-6.43V54.14h6.43Zm0,15h-6.43V69.12h6.43Zm0,15h-6.43V84.11h6.43Zm0,15h-6.43V99.09h6.43Zm0,17.09h-6.43v-11.8h6.43Zm-41.61,0v-11.8h6.43v11.8Z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.42,
    y: 69.12,
    width: 6.43,
    height: 9.69,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.87,
    y: 99.12,
    width: 6.43,
    height: 9.69,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.87,
    y: 54.14,
    width: 6.43,
    height: 9.69,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.42,
    y: 114.08,
    width: 18.16,
    height: 14.97,
    fill: "#f6f6f6",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.92,
    y: 111.48,
    width: 23.16,
    height: 4,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("polyline", {
    points: "124.61 129.05 129.66 126.53 129.66 46.74 124.6 48.84",
    fill: "#999",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.66 46.74 124.61 48.85 72.4 48.85 77.44 46.74 129.66 46.74",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployment);
export default __webpack_public_path__ + "static/media/employment.bcb87b21.svg";
export { ForwardRef as ReactComponent };